/* @flow */

export const MARKET_AUTOCOMPLETE_TOPICS = 'MARKET_AUTOCOMPLETE_TOPICS';
